import { createContext, useEffect, useState } from "react";
import * as request from "../admin/lib/lib";

export const RegisterContext = createContext();

export const RegisterProvider = ({ children }) => {

    const [commonAdvantages, setCommonAdvantages] = useState([]);
    const [sedentaryGroups, setSedentaryGroups] = useState([]);
    const [advantages, setAdvantages] = useState([]);
    const [schools, setSchools] = useState([]);
    const [isFormValid, setIsFormValid] = useState(false);

    const toggleFormToValid = () => {
        setIsFormValid(true);
    }

    const toggleFormToInvalid = () => {
        setIsFormValid(false);
    }

    useEffect(() => {
        try {
            request.get(process.env.REACT_APP_BACKEND_URL + 'Register/SedentaryGroups')
                .then((data) => {
                    setSedentaryGroups(data);
                })

            request.get(process.env.REACT_APP_BACKEND_URL + 'Register/Advantages')
                .then((data) => {
                    setAdvantages(data.filter(x => x.isAll === 0));
                    setCommonAdvantages(data.filter(x => x.isAll === 1));
                })

            request.get(process.env.REACT_APP_BACKEND_URL + `Register/Schools`)
                .then((data) => {
                    setSchools(data);
                })
        } catch (e) {
            console.error('Error fetching data:', e);
        }

    }, [])

    return (
        <RegisterContext.Provider value={
            {
                commonAdvantages,
                advantages,
                schools,
                isFormValid,
                toggleFormToValid,
                toggleFormToInvalid,
                sedentaryGroups
            }}>
            {children}
        </RegisterContext.Provider>
    )
}